<template>
    <div class="container fondo">
        <img src="../assets/bg/pre4.jpg" alt="" class="bg">
        <img src="../assets/bg/pre4-celular.jpg" alt="" class="bgcel">
        <div class="contbut">
            
        </div>
    </div>  
    <div class="container contpre">
        <div class="col-lg-7 divpre3">
            <Control 
                p="¿Por qué se recomienda no arrojar desechos por las rejillas o los desagües?"
                estilo="pregunta4"
                link="p5"
                r1="Porque los desechos se quedan encerrados y solos para siempre."
                r2="Porque contaminan el agua de los ríos."
                r3="Porque se pierden y sus familiares los extrañarían."
                real = "b"
            
            />
        </div>
    </div>
    
</template>

<script>
import Control from "@/components/Control";
import Fondos from '@/components/Fondos.vue'
export default {
    components:{
        Control,
        Fondos
    }
}
</script>


